// import React, { useState, useEffect } from "react";
import React, { useState, useEffect, useRef } from "react";
import AdminLeft from "./AdminLeft";
import TopBanner from "./TopBanner";
import Swal from "sweetalert2";

import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

import "./Visiting.css";

import "./fonts/NotoSansMalayalam-Regular-normal";

import { Editor } from "@tinymce/tinymce-react";

import Quill from "quill";
import "quill/dist/quill.snow.css";

export default function Visiting() {

  const [showPrescriptionPopup, setShowPrescriptionPopup] = useState(false);
  const [selectedVisit, setSelectedVisit] = useState(null);
  const [popupEditMode, setPopupEditMode] = useState(false);
  const [popupPrescription, setPopupPrescription] = useState("");

  const [open, setOpen] = useState(true);

  // Sidebar auto collapse
  useEffect(() => {
    const handleResize = () => {
      setOpen(window.innerWidth >= 768);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);


  const [formData, setFormData] = useState({
    name: "",
    bname: "",
    phone: "",
    age: "",
    sex: "",
    star: "",
    remarks: ""
  });

  const editorRef = useRef(null);
  const quillRef = useRef(null);

  useEffect(() => {
    if (!editorRef.current) return;

    // Prevent double initialization (React 19 Strict Mode)
    if (quillRef.current) return;

    const container = editorRef.current;

    quillRef.current = new Quill(container, {
      theme: "snow",
      modules: {
        toolbar: [
          ["bold", "italic", "underline"],
          [{ list: "ordered" }, { list: "bullet" }],
          ["link"],
          [{ align: [] }]
        ]
      }
    });

    // Set initial content
    quillRef.current.root.innerHTML = formData.prescription || "";

    // Listen for changes
    quillRef.current.on("text-change", () => {
      const html = quillRef.current.root.innerHTML;
      setFormData((prev) => ({ ...prev, prescription: html }));
    });

    // Cleanup (VERY IMPORTANT for React 19)
    return () => {
      quillRef.current = null;
    };
  }, []);



  const validateForm = () => {

    if (!form.phone) {
      return "Enter phone number to get details of the believer";
    }

    if (!/^\d{10}$/.test(form.phone)) {
      return "Phone Number must be 10 digits";
    }



    return null;
  };


  const [search, setSearch] = useState("");
  const [editId, setEditId] = useState(null);



  const handleSave = async () => {
    if (!formData.phone) {
      Swal.fire("Error", "Phone required", "warning");
      return;
    }

    const url = editId
      ? "https://kol.cubixsystems.com/api/update_visit.php"
      : "https://kol.cubixsystems.com/api/save_visit.php";

    try {
      // 🔄 STEP 1: SAVING DATA
      Swal.fire({
        title: editId ? "Updating..." : "Saving...",
        text: "Please wait",
        allowOutsideClick: false,
        didOpen: () => Swal.showLoading()
      });

      const res = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          ...formData,
          id: editId
        })
      });

      const result = await res.json();

      if (!result.success) {
        Swal.fire(
          "Error",
          editId ? "Failed to update data" : "Failed to save data",
          "error"
        );
        return;
      }

      // =====================================================
      // TEMPORARILY DISABLED
      // PDF GENERATION
      // PDF UPLOAD
      // WHATSAPP SENDING
      // =====================================================

      /*
      // 🔄 STEP 2: GENERATING PDF
  
      const row = {
        visit_date: new Date().toISOString(),
        prescription: formData.prescription,
        name: formData.name
      };
  
      handlePrint(row);
  
      function getBase64Image(url) {
        return new Promise((resolve, reject) => {
          const img = new Image();
          img.crossOrigin = "anonymous";
  
          img.onload = function () {
            const canvas = document.createElement("canvas");
            canvas.width = img.width;
            canvas.height = img.height;
  
            const ctx = canvas.getContext("2d");
            ctx.drawImage(img, 0, 0);
  
            resolve(canvas.toDataURL("image/png"));
          };
  
          img.onerror = reject;
          img.src = url;
        });
      }
  
      const doc = new jsPDF();
  
      doc.setFont("NotoSansMalayalam-Regular", "normal");
  
      const base64Image = await getBase64Image(
        "/images/Astrologer.jpeg"
      );
  
      const d = new Date(row.visit_date);
  
      const formattedDate =
        `${String(d.getDate()).padStart(2, "0")}-` +
        `${String(d.getMonth() + 1).padStart(2, "0")}-` +
        `${d.getFullYear()}`;
  
      doc.addImage(
        base64Image,
        "PNG",
        0,
        0,
        210,
        297
      );
  
      doc.text(
        `Date: ${formattedDate}`,
        125,
        90
      );
  
      const splitText = doc.splitTextToSize(
        row.prescription || "",
        160
      );
  
      doc.text(
        splitText,
        50,
        100
      );
  
      const pdfBlob = doc.output("blob");
  
      // 🔄 STEP 3: UPLOADING PDF
  
      const formDataUpload = new FormData();
  
      formDataUpload.append(
        "file",
        pdfBlob,
        "Kurippu.pdf"
      );
  
      const uploadRes = await fetch(
        "https://kol.cubixsystems.com/api/upload_pdf.php",
        {
          method: "POST",
          body: formDataUpload
        }
      );
  
      const uploadResult = await uploadRes.json();
  
      // 🔄 STEP 4: WHATSAPP
  
      if (uploadResult && uploadResult.url) {
  
        const phone = formData.phone;
  
        const message = encodeURIComponent(
          `Hello ${row.name},
  
  Your Kurippu is ready 📄
  
  ${uploadResult.url}`
        );
  
        const whatsappURL =
          `https://wa.me/91${phone}?text=${message}`;
  
        window.open(
          whatsappURL,
          "_blank"
        );
      }
      */

      // =====================================================
      // CURRENT FINAL ACTION
      // =====================================================

      Swal.fire({
        icon: "success",
        title: editId ? "Updated Successfully" : "Saved Successfully",
        text: "Visit details have been saved.",
        timer: 1800,
        showConfirmButton: false
      });

      // Reset edit mode
      setEditId(null);

      // Refresh visit history
      handleSearch();

    } catch (err) {
      console.error("FINAL ERROR:", err);

      Swal.fire(
        "Error",
        "Something went wrong",
        "error"
      );
    }
  };



  const generateStyledPDF = async (row) => {
    const doc = new jsPDF({
      orientation: "portrait",
      unit: "mm",
      format: "a5"
    });

    const formatDate = (dateString) => {
      const d = new Date(dateString);
      return `${String(d.getDate()).padStart(2, "0")}-${String(
        d.getMonth() + 1
      ).padStart(2, "0")}-${d.getFullYear()}`;
    };

    const formattedDate = formatDate(row.visit_date);

    try {
      const imgData = await getBase64FromUrl("/images/Astrologer-.jpeg");

      doc.addImage(imgData, "JPEG", 0, 0, 148, 210);

      doc.setFont("helvetica", "bold");
      doc.setFontSize(10);

      doc.text(`Date: ${formattedDate}`, 100, 40);

      doc.setFont("helvetica", "normal");
      doc.setFontSize(12);

      const splitText = doc.splitTextToSize(row.prescription || "", 80);

      doc.text(splitText, 55, 70);

      return doc;
    } catch (err) {
      console.error("Image load failed", err);
      return doc;
    }
  };

  const getBase64FromUrl = async (url) => {
    const data = await fetch(url);
    const blob = await data.blob();

    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.readAsDataURL(blob);
      reader.onloadend = () => resolve(reader.result);
    });
  };

  const generateExactPDFfromHTML = async (row) => {
    const formatDate = (dateString) => {
      const d = new Date(dateString);
      return `${String(d.getDate()).padStart(2, "0")}-${String(
        d.getMonth() + 1
      ).padStart(2, "0")}-${d.getFullYear()}`;
    };

    const formattedDate = formatDate(row.visit_date);

    // 👉 SAME HTML AS YOUR PRINT
    const htmlContent = `
      <div style="
        width:148mm;
        height:210mm;
        background-image:url('./images/Astrologer-.jpeg');
        background-size:cover;
        position:relative;
        font-family: Tahoma;
      id="pdfContainer">
        <div style="
         
          top:220px;
          left:55px;
          width:80%;
        ">
        <h1>Sandheep Warrior</h1>
          <p style="text-align:right;">
            <strong>Date:</strong> ${formattedDate}
          </p>
  
          <p style="margin-top:30px;font-family:Noto Sans Malayalam">
            ${row.prescription || ""}
          </p>
        </div>
      </div>
    `;

    const container = document.getElementById("pdfContainer");
    container.innerHTML = htmlContent;

    const element = container.firstChild;

    const canvas = await html2canvas(element, {
      scale: 3,
      useCORS: true
    });

    const imgData = canvas.toDataURL("image/png");

    const pdf = new jsPDF({
      orientation: "portrait",
      unit: "mm",
      format: "a5"
    });

    pdf.addImage(imgData, "PNG", 0, 0, 148, 210);

    return pdf;
  };





  const generatePDFAndSendWhatsApp = async (row) => {
    try {
      // ✅ STEP 1: Generate styled PDF
      const doc = await generateExactPDFfromHTML(row);

      // 👉 Convert to blob
      //const pdfBlob = doc.output("blob");

      const pdf = await generateExactPDFfromHTML(row);
      const pdfBlob = pdf.output("blob");

      // ============================
      // ☁️ UPLOAD
      // ============================
      const formDataUpload = new FormData();
      formDataUpload.append("file", pdfBlob, "kurippu.pdf");

      const uploadRes = await fetch(
        "https://kol.cubixsystems.com/api/upload_pdf.php",
        {
          method: "POST",
          body: formDataUpload
        }
      );

      let uploadResult = {};

      try {
        uploadResult = await uploadRes.json();
      } catch (e) {
        console.warn("Invalid JSON");
      }

      // ============================
      // 📲 WHATSAPP
      // ============================
      if (uploadResult && uploadResult.url) {
        const phone = form.phone;

        const message = encodeURIComponent(
          `Hello ${row.name},
  
  Your prescription is ready 📄
  
  Download here:
  ${uploadResult.url}`
        );

        const whatsappURL = `https://wa.me/91${phone}?text=${message}`;

        window.open(whatsappURL, "_blank");
      } else {
        // ❗ fallback
        doc.save("prescription.pdf");

        Swal.fire(
          "Warning",
          "PDF upload failed. Downloaded locally.",
          "warning"
        );
      }
    } catch (err) {
      console.error(err);
    }
  };

  const handleCancel = () => {

    window.location.reload();
    setFormData({
      name: "",
      phone: "",
      age: "",
      sex: "",
      star: "",
      remarks: ""
    });

    setEditId(null);
  };

  const [form, setForm] = useState({
    name: "",
    phone: "",
    ageFrom: "",
    ageTo: "",
    caste: "",
    star: "",
    sex: "",
    fromDate: "",
    toDate: ""
  });

  const [data, setData] = useState([]);
  const [showTable, setShowTable] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleEntryChange = (index, field, value) => {
    const updated = [...form.entries];
    updated[index][field] = value;

    setForm({ ...form, entries: updated });
  };

  const handleSearchChange = (e) => {
    const value = e.target.value.replace(/\D/g, "");
    if (value.length <= 10) {
      setForm({ ...form, phone: value });
    }
  };



  const handleSearch = async () => {
    const error = validateForm();

    if (error) {
      Swal.fire({
        icon: "warning",
        title: "Search",
        text: error
      });
      return;

    }
    setShowTable(false);
    setLoading(true);

    try {
      const res = await fetch(
        `https://kol.cubixsystems.com/api/search_patient.php?phone=${form.phone}`
      );
      const result = await res.json();

      if (result.believer) {
        setFormData(result.believer);
        setData(result.visits); // visit history
      } else {
        Swal.fire("Believer", "No record found", "info");
        // setFormData({ ...formData, phone: form.phone });
        // setData([]);
        window.location.reload();

      }

      setShowTable(true);
    } catch (err) {
      console.error(err);
    }

    setLoading(false);
  };

  const handleEdit = (row) => {
    setSelectedVisit(row);
    setPopupPrescription(row.prescription || "");
    setPopupEditMode(false);
    setShowPrescriptionPopup(true);
  };



  const handlePrint = (row) => {
    const printWindow = window.open("", "_blank");

    const name = row.name || formData.name || "";
    const bname = row.bname || formData.bname || "";
    const star = row.star || formData.star || "";
    const age = row.age || formData.age || "";
    const native = row.native || formData.native || "";
    const prescription = row.prescription || "";

    // 📅 DATE FORMAT
    const formatPrintDate = (dateString) => {
      if (!dateString) return "";

      const d = new Date(dateString.replace(" ", "T"));

      return new Intl.DateTimeFormat("en-IN", {
        timeZone: "Asia/Kolkata",
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      }).format(d);
    };

    const formattedDate = formatPrintDate(row.visit_date);

    // 🔥 HEIGHT-BASED SPLIT (PERFECT FIX)
    const splitByHeight = (text, heights) => {
      const words = text.split(" ");
      const pages = [];

      const temp = document.createElement("div");

      temp.style.position = "absolute";
      temp.style.visibility = "hidden";
      temp.style.width = "480px";
      temp.style.fontFamily = "Noto Sans Malayalam, Tahoma";
      temp.style.fontSize = "14px";
      temp.style.lineHeight = "1.3";
      temp.style.whiteSpace = "pre-wrap";
      temp.style.wordBreak = "break-word";

      document.body.appendChild(temp);

      let current = "";
      let pageIndex = 0;

      words.forEach((word) => {
        const test = current + word + " ";
        temp.innerText = test;

        const maxHeight =
          pageIndex === 0 ? heights.firstPage : heights.otherPages;

        if (temp.offsetHeight > maxHeight) {
          pages.push(current.trim());
          current = word + " ";
          pageIndex++;
        } else {
          current = test;
        }
      });

      if (current.trim()) {
        pages.push(current.trim());
      }

      document.body.removeChild(temp);

      return pages;
    };

    // 🔥 PERFECT HEIGHTS (A5 OPTIMIZED)
    const prescriptionPages = splitByHeight(prescription, {
      firstPage: 360,   // smaller due to name/date block
      otherPages: 450,  // full usable height
    });

    // 🖨 PRINT WINDOW
    printWindow.document.write(`
  <html>
  <head>
    <title>Print</title>
  
    <style>
      @page {
        size: A5;
        margin: 0;
      }
  
      body {
        margin: 0;
        font-family: "Noto Sans Malayalam", Tahoma;
      }
  
      /* HEADER */
      .header {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 220px;
        background-image: url('/images/Astrologer-.jpeg');
        background-size: cover;
        background-repeat: no-repeat;
        -webkit-print-color-adjust: exact;
        print-color-adjust: exact;
      }
  
      /* FOOTER */
      .footer {
        position: fixed;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 50px;
        text-align: center;
        font-size: 12px;
        background: black;
        color: white;
      }
  
      /* PAGE */
      .page {
        page-break-after: always;
        break-after: page;
        height: 100vh;
        box-sizing: border-box;
  
        padding-top: 220px;
        padding-bottom: 50px;
        padding-left: 55px;
        padding-right: 40px;
      }
  
      /* PRESCRIPTION */
      .prescription {
        margin-top: 20px;
        white-space: pre-wrap;
        word-break: break-word;
        line-height: 1.3;
        font-size: 14px;
        // border: 1px solid silver;
        // padding: 10px;
      }
  
    </style>
  </head>
  
  <body>
  
    <!-- HEADER -->
    <div class="header"></div>
  
    <!-- FOOTER -->
    <div class="footer">
      <p>
        Time: 9 am to 6 pm | ഞായർ അവധി | Kolath Medicals
      </p>
    </div>
  
    ${prescriptionPages
        .map(
          (chunk, index) => `
        <div class="page">
  
          ${index === 0
              ? `
            <p style="text-align:right;">
              <strong>Date:</strong> ${formattedDate}
            </p>
  
            <p style="margin-top:30px">
              ${native} ${bname}<br/>
              ${star} ${name}, Age: ${age} 
            </p>
          `
              : ``
            }
  
          <div class="prescription">
  ${chunk}
          </div>
  
        </div>
      `
        )
        .join("")}
  
    <script>
      window.onload = function() {
        window.print();
        setTimeout(() => window.close(), 500);
      };
    </script>
  
  </body>
  </html>
  `);

    printWindow.document.close();
  };

  const handleDelete = (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "This visit will be deleted",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it"
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const res = await fetch(
            `https://kol.cubixsystems.com/api/delete_visit.php?id=${id}`
          );
          const data = await res.json();

          if (data.success) {
            Swal.fire("Deleted!", "Visit removed", "success");
            handleSearch(); // refresh
          }
        } catch (err) {
          console.error(err);
        }
      }
    });
  };

  const formatDate = (dateString) => {
    const dateObj = new Date(dateString);

    const day = String(dateObj.getDate()).padStart(2, "0");
    const month = String(dateObj.getMonth() + 1).padStart(2, "0");
    const year = dateObj.getFullYear();

    return `${day}-${month}-${year}`;
  };

  const exportToExcel = () => {
    const exportData = data.map((row, i) => ({
      "Sl No": i + 1,
      RegNo: row.regNo,
      Name: row.name,
      Caste: row.caste,
      Age: row.age,
      Height: row.height,
      Star: row.star,
      Dhosham: row.dhosham,
      Qualification: row.qualification,
      Occupation: row.job,
      Native: row.native,
      Phone: row.phone
      //Date: formatDate(row.date),
    }));

    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Search Results");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array"
    });

    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(blob, "Report.xlsx");
  };

  const exportToPDF = () => {
    const doc = new jsPDF("landscape", "mm", "a4");

    const tableColumn = [
      "Sl No",
      "Reg No",
      "Name",
      "Caste",
      "Age",
      "Height",
      "Star",
      "Dhosham",
      "Qualification",
      "Occupation",
      "Native",
      "Phone"

    ];

    const tableRows = data.map((row, i) => [
      i + 1,
      row.regNo,
      row.name,
      row.caste,
      row.age,
      row.height,
      row.star,
      row.dhosham,
      row.qualification,
      row.job,
      row.native,
      row.phone,
      row.phone,
      // formatDate(row.date)
    ]);

    doc.text("", 14, 10);

    autoTable(doc, {
      head: [tableColumn],
      body: tableRows,
      startY: 20
    });

    doc.save("Report.pdf");
  };

  // Language Selection
  const [text, setText] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [selectedLang, setSelectedLang] = useState("en");
  const [showDropdown, setShowDropdown] = useState(false);

  const debounceRef = useRef(null);
  const inputRef = useRef(null);

  // 🔹 Fetch Suggestions (Debounced)
  useEffect(() => {
    clearTimeout(debounceRef.current);

    debounceRef.current = setTimeout(() => {
      fetchSuggestions();
    }, 300);

    return () => clearTimeout(debounceRef.current);
  }, [formData.prescription, selectedLang]); // ✅ FIXED

  const fetchSuggestions = async () => {
    const currentText = formData.prescription || "";
    const cursorPos = inputRef.current?.selectionStart || 0;

    // ✂️ Get text before cursor
    const textBeforeCursor = currentText.slice(0, cursorPos);

    // 🔍 Get current word near cursor
    const match = textBeforeCursor.match(/(\S+)$/);
    const lastWord = match ? match[0] : "";

    if (!lastWord.trim()) {
      setSuggestions([]);
      setShowDropdown(false);
      return;
    }

    if (selectedLang === "en") {
      setSuggestions([]);
      setShowDropdown(false);
      return;
    }

    try {
      let response = await fetch(
        `https://inputtools.google.com/request?text=${lastWord}&itc=${selectedLang}-t-i0-und&num=5`
      );

      let data = await response.json();

      if (data[0] === "SUCCESS") {
        setSuggestions(data[1][0][1]);
        setShowDropdown(true);
      }
    } catch (err) {
      console.error(err);
    }
  };

  // 🔹 Handle Space (Auto Convert)
  const handleKeyDown = async (e) => {
    const currentText = formData.prescription || "";
    const cursorPos = e.target.selectionStart;

    if (e.key === "Enter") {
      setShowDropdown(false);
      return;
    }

    if (e.key === " ") {
      e.preventDefault();

      // ✂️ Split text at cursor
      const before = currentText.slice(0, cursorPos);
      const after = currentText.slice(cursorPos);

      // 🔍 Find word before cursor
      const match = before.match(/(\S+)$/);
      const lastWord = match ? match[0] : "";

      if (!lastWord) {
        setFormData({
          ...formData,
          prescription: before + " " + after,
        });
        return;
      }

      // ✅ ENGLISH → no conversion
      if (selectedLang === "en") {
        setFormData({
          ...formData,
          prescription: before + " " + after,
        });
        return;
      }

      try {
        let response = await fetch(
          `https://inputtools.google.com/request?text=${lastWord}&itc=${selectedLang}-t-i0-und&num=5`
        );

        let data = await response.json();

        let converted = lastWord;

        if (
          data[0] === "SUCCESS" &&
          data[1]?.[0]?.[1]?.length > 0
        ) {
          converted = data[1][0][1][0];
        }

        // 🔁 Replace only that word
        const newBefore = before.replace(/(\S+)$/, converted);

        setFormData({
          ...formData,
          prescription: newBefore + " " + after,
        });

      } catch (err) {
        console.error(err);
      }

      setSuggestions([]);
      setShowDropdown(false);
    }
  };

  // 🔹 Click Suggestion
  const selectSuggestion = (value) => {
    const currentText = formData.prescription || "";
    const cursorPos = inputRef.current.selectionStart;

    const before = currentText.slice(0, cursorPos);
    const after = currentText.slice(cursorPos);

    const newBefore = before.replace(/(\S+)$/, value);

    setFormData({
      ...formData,
      prescription: newBefore + " " + after,
    });

    setSuggestions([]);
    setShowDropdown(false);

    inputRef.current.focus();
  };



  return (
    <div className="container-fluid p-0">
      <div className="d-flex" style={{ height: "100vh" }}>
        <div
          className="top-0 start-0 p-2 fs-3 rounded shadow-sm"
          style={{
            zIndex: 999,
            cursor: "pointer",
            position: "fixed",
            left: open ? "350px" : "60px",
            top: "0",
            transition: "left 0.3s ease"
          }}
          onClick={() => setOpen(!open)}
        >
          <span className="displaysidemenu" style={{ position: "absolute", right: "-10px" }}>
            ☰
          </span>
        </div>
        <div
          className="border-end leftcolor"
          style={{
            width: open ? "350px" : "0",
            overflow: "hidden",
            transition: "0.3s ease"
          }}
        >
          {open && (
            <div className="p-3">
              <AdminLeft />
            </div>
          )}
        </div>

        {/* RIGHT CONTENT */}
        <div
          className="p-4"
          style={{
            width: open ? "calc(100% - 350px)" : "100%",
            transition: "0.3s ease",
            paddingLeft: "30px"
          }}
        >
          <TopBanner />
          <div className="visiting-page" style={{overflow:'auto',height:'60vh'}}>

            <div className="visiting-container">

              {/* =========================
        SEARCH
    ========================= */}
              <div className="visiting-search-card">

                <h2 className="search-title">
                  Patient Visit
                </h2>

                <p className="search-subtitle">
                  Search patient details using registered phone number
                </p>

                <div className="search-row">

                  <div className="phone-wrapper">

                    <i className="fa fa-phone phone-icon"></i>

                    <input
                      className="phone-input"
                      name="phone"
                      placeholder="Enter Phone Number"
                      value={form.phone}
                      maxLength={10}
                      inputMode="numeric"
                      onChange={handleSearchChange}
                    />

                  </div>

                  <button
                    className="search-btn"
                    onClick={handleSearch}
                  >
                    <i className="fa fa-search"></i>
                    Search Patient
                  </button>

                </div>

                {loading && (
                  <div className="loading-message">
                    <i className="fa fa-spinner fa-spin"></i>
                    &nbsp; Searching patient...
                  </div>
                )}

              </div>


              {/* =========================
        PATIENT WORKSPACE
    ========================= */}

              {showTable && (

                <div className="visiting-workspace">

                  {/* ===================================
            LEFT : PATIENT + PRESCRIPTION
        =================================== */}

                  <div className="patient-card">

                    {/* HEADER */}

                    <div className="card-header-modern">

                      <div className="card-title-area">

                        <div className="card-title-icon">
                          <i className="fa fa-user-md"></i>
                        </div>

                        <div>

                          <h3 className="card-title">
                            Patient Details
                          </h3>

                          <p className="card-subtitle">
                            Patient information & prescription
                          </p>

                        </div>

                      </div>

                    </div>


                    {/* ===================================
              PATIENT INFORMATION
          =================================== */}

                    <div className="patient-info">

                      <div className="patient-info-item">

                        <span className="patient-info-label">
                          Name
                        </span>

                        <span className="patient-info-value">
                          {formData.name || "-"}
                        </span>

                      </div>


                      <div className="patient-info-item">

                        <span className="patient-info-label">
                          Phone
                        </span>

                        <span className="patient-info-value">
                          {formData.phone || "-"}
                        </span>

                      </div>


                      <div className="patient-info-item">

                        <span className="patient-info-label">
                          Age
                        </span>

                        <span className="patient-info-value">
                          {formData.age || "-"}
                        </span>

                      </div>


                      <div className="patient-info-item">

                        <span className="patient-info-label">
                          Gender
                        </span>

                        <span className="patient-info-value">
                          {formData.sex || "-"}
                        </span>

                      </div>


                      <div className="patient-info-item">

              <span className="patient-info-label">
                MR ID
              </span>

              <span className="patient-info-value">
                {formData.star || "-"}
              </span>

            </div>

                    </div>


                    {/* ===================================
              HIDDEN FIELDS
          =================================== */}

                    <input
                      name="name"
                      type="hidden"
                      value={formData.name || ""}
                      readOnly
                    />

                    <input
                      name="phone"
                      type="hidden"
                      value={formData.phone || ""}
                      readOnly
                    />

                    <input
                      name="age"
                      type="hidden"
                      value={formData.age || ""}
                      readOnly
                    />


                    {/* ===================================
              PRESCRIPTION
          =================================== */}

                    <div className="prescription-section">

                      <div className="prescription-label-row">

                        <label className="prescription-label">
                          <i className="fa fa-file-text-o"></i>
                          &nbsp; New Prescription
                        </label>

                        <span className="prescription-hint">
                          Enter consultation details
                        </span>

                      </div>


                      <div className="prescription-editor-wrapper">

                        <textarea
                          className="prescription-editor"
                          ref={inputRef}
                          value={formData.prescription || ""}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              prescription: e.target.value
                            })
                          }
                          onKeyDown={handleKeyDown}
                          placeholder="Enter Prescription..."
                        />


                        {/* =========================
                  GOOGLE SUGGESTIONS
              ========================= */}

                        {showDropdown &&
                          suggestions.length > 0 && (

                            <div
                              style={{
                                position: "absolute",
                                left: "15px",
                                right: "15px",
                                bottom: "15px",
                                background: "#ffffff",
                                border: "1px solid #dce4eb",
                                borderRadius: "10px",
                                maxHeight: "220px",
                                overflowY: "auto",
                                zIndex: 9999,
                                boxShadow:
                                  "0 8px 25px rgba(0,0,0,0.15)"
                              }}
                            >

                              {suggestions.map((item, index) => (

                                <div
                                  key={index}
                                  onClick={() =>
                                    selectSuggestion(item)
                                  }
                                  style={{
                                    padding: "12px 15px",
                                    cursor: "pointer",
                                    fontSize: "16px",
                                    color: "#000000",
                                    borderBottom:
                                      "1px solid #edf1f5"
                                  }}
                                  onMouseOver={(e) => {
                                    e.currentTarget.style.background =
                                      "#f2f8f9";
                                  }}
                                  onMouseOut={(e) => {
                                    e.currentTarget.style.background =
                                      "#ffffff";
                                  }}
                                >
                                  {item}
                                </div>

                              ))}

                            </div>

                          )}

                      </div>


                      {/* =========================
                BUTTONS
            ========================= */}

                      <div className="prescription-actions">

                        <button
                          className="save-btn"
                          onClick={handleSave}
                        >
                          <i className="fa fa-save"></i>
                          &nbsp;
                          {editId ? "Update Prescription" : "Save Prescription"}
                        </button>

                        <button
                          className="cancel-btn"
                          onClick={handleCancel}
                        >
                          <i className="fa fa-times"></i>
                          &nbsp;
                          Cancel
                        </button>

                      </div>

                    </div>

                  </div>


                  {/* ===================================
            RIGHT : VISIT HISTORY
        =================================== */}

                  <div className="history-card">

                    <div className="history-header">

                      <h3 className="history-title">
                        <i className="fa fa-history"></i>
                        &nbsp; Visit History
                      </h3>

                      <p className="history-subtitle">
                        Previous consultations
                      </p>

                    </div>


                    <div className="history-table-wrapper">

                      <table className="history-table">

                        <thead>

                          <tr>

                            <th style={{width:'10%'}}>No.</th>

                            {/* <th>MR No.</th> */}

                            <th style={{width:'30%'}}>Visited Date</th>

                            <th style={{width:'60%'}}>Actions</th>

                          </tr>

                        </thead>


                        <tbody>

                          {data.length > 0 ? (

                            data.map((row, i) => (

                              <tr key={row.id}>

                                <td>

                                  <span className="visit-number">
                                    {i + 1}
                                  </span>

                                </td>


                                {/* <td>
                                  MR001
                                </td> */}


                                <td>

                                  {row.visit_date
                                    ? new Intl.DateTimeFormat(
                                      "en-IN",
                                      {
                                        timeZone: "Asia/Kolkata",
                                        day: "2-digit",
                                        month: "short",
                                        year: "numeric",
                                        hour: "2-digit",
                                        minute: "2-digit",
                                        hour12: true
                                      }
                                    ).format(
                                      new Date(
                                        row.visit_date.replace(
                                          " ",
                                          "T"
                                        )
                                      )
                                    )
                                    : "-"}

                                </td>


                                <td>

                                  <div className="history-actions">

                                    {/* VIEW */}

                                    <button
                                      className="history-action view"
                                      title="View / Edit"
                                      onClick={() =>
                                        handleEdit(row)
                                      }
                                    >
                                      <i className="fa fa-eye"></i>
                                    </button>


                                    {/* DELETE */}

                                    <button
                                      className="history-action delete"
                                      title="Delete"
                                      onClick={() =>
                                        handleDelete(row.id)
                                      }
                                    >
                                      <i className="fa fa-trash"></i>
                                    </button>


                                    {/* PRINT */}

                                    <button
                                      className="history-action print"
                                      title="Print"
                                      onClick={() =>
                                        handlePrint(row)
                                      }
                                    >
                                      <i className="fa fa-print"></i>
                                    </button>

                                  </div>

                                </td>

                              </tr>

                            ))

                          ) : (

                            <tr>

                              <td
                                colSpan="4"
                                style={{
                                  textAlign: "center",
                                  padding: "35px"
                                }}
                              >
                                No visit history found
                              </td>

                            </tr>

                          )}

                        </tbody>

                      </table>

                    </div>

                  </div>

                </div>

              )}

            </div>

          </div>
        </div>
      </div>
      {/* =====================================================
    PRESCRIPTION VIEW / UPDATE POPUP
===================================================== */}

      {showPrescriptionPopup && selectedVisit && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0,0,0,0.65)",
            zIndex: 99999,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "20px"
          }}
        >

          <div
            style={{
              width: "700px",
              maxWidth: "100%",
              maxHeight: "90vh",
              background: "#fff",
              borderRadius: "10px",
              boxShadow: "0 10px 40px rgba(0,0,0,0.3)",
              overflow: "hidden",
              display: "flex",
              flexDirection: "column"
            }}
          >

            {/* HEADER */}

            <div
              style={{
                background: "#004962",
                color: "#fff",
                padding: "15px 20px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center"
              }}
            >

              <div>
                <h5 style={{
                  margin: 0,
                  color: "#ffffff",
                  fontWeight: "600"
                }}>
                  Prescription Details
                </h5>

                <small>
                  Visit Date:{" "}
                  {selectedVisit.visit_date
                    ? new Intl.DateTimeFormat("en-IN", {
                      timeZone: "Asia/Kolkata",
                      day: "2-digit",
                      month: "2-digit",
                      year: "numeric",
                      hour: "2-digit",
                      minute: "2-digit",
                      hour12: true
                    }).format(
                      new Date(
                        selectedVisit.visit_date.replace(" ", "T")
                      )
                    )
                    : ""}
                </small>
              </div>

              <button
                onClick={() => {
                  setShowPrescriptionPopup(false);
                  setPopupEditMode(false);
                }}
                style={{
                  background: "transparent",
                  border: "none",
                  color: "#fff",
                  fontSize: "25px",
                  cursor: "pointer"
                }}
              >
                ×
              </button>

            </div>


            {/* PATIENT INFORMATION */}

            <div
              style={{
                padding: "15px 20px",
                borderBottom: "1px solid #ddd",
                background: "#f8f9fa",
              }}
            >

              <div className="row">

                <div className="col-md-4" style={{ color: 'black' }}>
                  <strong>Name</strong>
                  <br />
                  {formData.name}
                </div>

                <div className="col-md-4" style={{ color: 'black' }}>
                  <strong>Phone</strong>
                  <br />
                  {formData.phone}
                </div>

                <div className="col-md-4" style={{ color: 'black' }}>
                  <strong>Age</strong>
                  <br />
                  {formData.age}
                </div>

              </div>

            </div>


            {/* PRESCRIPTION */}

            <div
              style={{
                padding: "20px",
                overflowY: "auto",
                flex: 1
              }}
            >

              {!popupEditMode ? (

                /* READ ONLY VIEW */

                <div
                  style={{
                    minHeight: "250px",
                    border: "1px solid #ddd",
                    borderRadius: "6px",
                    padding: "15px",
                    background: "#fafafa",
                    color: "#000000",
                    whiteSpace: "pre-wrap",
                    fontFamily: "Anek Malayalam, Noto Sans Malayalam, sans-serif",
                    fontSize: "16px",
                    lineHeight: "1.6"
                  }}
                >
                  {selectedVisit.prescription
                    ? selectedVisit.prescription
                    : "No prescription available."}
                </div>

              ) : (

                /* EDIT MODE */

                <textarea
                  value={popupPrescription}
                  onChange={(e) =>
                    setPopupPrescription(e.target.value)
                  }
                  style={{
                    width: "100%",
                    minHeight: "350px",
                    padding: "15px",
                    border: "1px solid #ccc",
                    borderRadius: "6px",
                    resize: "vertical",
                    fontFamily:
                      "Anek Malayalam, Noto Sans Malayalam, sans-serif",
                    fontSize: "16px",
                    lineHeight: "1.6",
                    outline: "none"
                  }}
                />

              )}

            </div>


            {/* FOOTER */}

            <div
              style={{
                padding: "15px 20px",
                borderTop: "1px solid #ddd",
                display: "flex",
                justifyContent: "flex-end",
                gap: "10px"
              }}
            >

              {!popupEditMode ? (

                <>
                  {/* UPDATE */}

                  <button
                    className="btn btn-warning"
                    onClick={() => {
                      setPopupEditMode(true);
                    }}
                  >
                    <i className="fa fa-edit"></i>{" "}
                    Edit
                  </button>

                  {/* CANCEL */}

                  <button
                    className="btn btn-secondary"
                    onClick={() => {
                      setShowPrescriptionPopup(false);
                      setPopupEditMode(false);
                    }}
                  >
                    Close
                  </button>
                </>

              ) : (

                <>
                  {/* SAVE UPDATE */}

                  <button
                    className="btn btn-success"
                    onClick={async () => {

                      if (!popupPrescription.trim()) {
                        Swal.fire(
                          "Warning",
                          "Prescription cannot be empty",
                          "warning"
                        );
                        return;
                      }

                      try {

                        Swal.fire({
                          title: "Updating...",
                          text: "Please wait",
                          allowOutsideClick: false,
                          didOpen: () => {
                            Swal.showLoading();
                          }
                        });

                        const response = await fetch(
                          "https://kol.cubixsystems.com/api/update_visit.php",
                          {
                            method: "POST",
                            headers: {
                              "Content-Type": "application/json"
                            },
                            body: JSON.stringify({
                              id: selectedVisit.id,
                              prescription: popupPrescription,
                              name: formData.name,
                              phone: formData.phone,
                              age: formData.age,
                              sex: formData.sex,
                              star: formData.star,
                              remarks: selectedVisit.remarks || ""
                            })
                          }
                        );

                        const result = await response.json();

                        if (result.success) {

                          Swal.fire({
                            icon: "success",
                            title: "Updated",
                            text: "Prescription updated successfully",
                            timer: 1500,
                            showConfirmButton: false
                          });

                          // Update selected visit locally
                          setSelectedVisit({
                            ...selectedVisit,
                            prescription: popupPrescription
                          });

                          setPopupEditMode(false);

                          // Refresh history
                          await handleSearch();

                        } else {

                          Swal.fire(
                            "Error",
                            result.message ||
                            "Failed to update prescription",
                            "error"
                          );

                        }

                      } catch (error) {

                        console.error(error);

                        Swal.fire(
                          "Error",
                          "Something went wrong while updating",
                          "error"
                        );

                      }

                    }}
                  >
                    <i className="fa fa-save"></i>{" "}
                    Save Update
                  </button>


                  {/* CANCEL EDIT */}

                  <button
                    className="btn btn-secondary"
                    onClick={() => {

                      // Restore original prescription
                      setPopupPrescription(
                        selectedVisit.prescription || ""
                      );

                      setPopupEditMode(false);

                    }}
                  >
                    Close
                  </button>

                </>

              )}

            </div>

          </div>

        </div>
      )}
    </div>
  );
}